import { render } from "./DeleteUserForm.vue?vue&type=template&id=68dbcb18"
import script from "./DeleteUserForm.vue?vue&type=script&lang=js"
export * from "./DeleteUserForm.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "68dbcb18"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('68dbcb18', script)) {
    api.reload('68dbcb18', script)
  }
  
  module.hot.accept("./DeleteUserForm.vue?vue&type=template&id=68dbcb18", () => {
    api.rerender('68dbcb18', render)
  })

}

script.__file = "resources/js/Pages/Profile/Partials/DeleteUserForm.vue"

export default script